import React, { useState, useRef, useEffect } from 'react';
import './App.css';

function App() {
    const [userRequestPrompt, setUserRequestPrompt] = useState('');
    const [theme, setTheme] = useState('light'); // 'light' or 'dark'
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto'; // Reset height to recalculate
            const scrollHeight = textareaRef.current.scrollHeight;
            const newHeight = Math.max(120, Math.min(scrollHeight, 480));
            textareaRef.current.style.height = `${newHeight}px`;
        }
    }, [userRequestPrompt]);

    const toggleTheme = () => {
        setTheme(theme === 'light' ? 'dark' : 'light');
    };

  return (
    <div className={`App ${theme}`}>
      <header className="App-header">
        <button className="theme-toggle-button" onClick={toggleTheme}>
            Switch to {theme === 'light' ? 'Dark' : 'Light'} Theme
        </button>
        <div className="textarea-container">
          <textarea
            ref={textareaRef}
            className="textarea-input"
            value={userRequestPrompt}
            onChange={(e) => setUserRequestPrompt(e.target.value)}
            maxLength={500}
            placeholder="Enter text (up to 500 characters)"
            style={{ overflowY: 'auto' }} // Add scrollbar if content exceeds max-height
          />
          <p className="char-counter">{userRequestPrompt.length} / 500</p>
        </div>
      </header>
    </div>
  );
}

export default App;
